$( document ).ready(function() {
  // $("#itg_gift_btn").click(function () {
  //  $('.itg_newsletter_popup').addClass("modal--is-active");
  // });  

  // $(".modal__close").click(function () {
  //  $('.itg_newsletter_popup').removeClass("modal--is-active");
  // });  

  $(document).on("click","span#itg_gift_btn",function() {
    $(document).find(".itg_newsletter_popup").css("display", "flex");
  });
   $(document).on("click",".modal__close",function() {
    $(document).find(".itg_newsletter_popup").css("display", "none");
     $(document).find("html").removeClass('modal-open');
  });
  
  var mySwiper = new Swiper ('.swiper', {
    direction: 'horizontal', // 
    loop: true, 
    autoplay: {
    delay: 5000,
  }
  });

    $(".dropdown-button").click(function() {
      $(this).siblings(".dropdown-content").toggle();
    });
  

  // $(document).on("click",".variant-input-wrap label",function() {
  //   setTimeout(function() {
  //     var searchParams = new URLSearchParams(window.location.search);
  //     var variantid = searchParams.get('variant');
  //       $("#custom_selection_varaint option").each(function(){
  //          var ths_id = $(this).val();
  //          if(ths_id == variantid){
  //            $(document).find("#set_qty").text('');
  //            var ths_qty = $(this).attr('data-qty');
  //            $(document).find("#set_qty").text(ths_qty);
  //          }
  //       });
  //   }, 800);    
  // });


 // ----------------mega menu---------------
  $(".itg_childlink_menu a").hover(function () {
    var Title = $(this).data("title");
    $(".itg_grandchildlink_menu .itg_grandchildlink").each(function () {
      var checkTitle = $(this).data("value");
      if (Title == checkTitle) {
        $(this).addClass("mega_active");
      } else {
        $(this).removeClass("mega_active");
      }
    });
  });  
    
 $(".custom_hover_img").hover(function(){  
  var src =  $(this).attr('data-coll-img'); 
  // console.log(src);
 $(this).closest('.itg_grand_link').find('.itg_coll_imgs').attr('src',src);
  });
  
 //   var frist_img = $('.mega_active .itg_grand_link ul li:first-child').attr('data-coll-img');
 // $('.mega_active .itg_menu_colle_img img').attr('src', frist_img);  
  
 //  });  
 // ----------------end mega menu---------------
  
}); // ----------------end document ready---------------